import { render, staticRenderFns } from "./FontAdd.vue?vue&type=template&id=1b1dcfb6&scoped=true"
import script from "./FontAdd.vue?vue&type=script&lang=js"
export * from "./FontAdd.vue?vue&type=script&lang=js"
import style0 from "./FontAdd.vue?vue&type=style&index=0&id=1b1dcfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1dcfb6",
  null
  
)

export default component.exports